export default __webpack_public_path__ + "static/sustainability-image-be1bd426b92619719a721879fa09c114.jpg";